import type { UserWorkspace } from '@/api/types'
import { byOrder } from '@/shared/lib/order'

/**
 * The workspace this application shows, which is the only one it has.
 *
 * A tenant gets exactly one, made by the identity provider path the first time its
 * alias is seen, and every member of the tenant is enrolled in it. So this is a
 * lookup rather than a selection -- there is nothing to switch between and nothing
 * to remember.
 *
 * The fallback is load-bearing rather than defensive. A provider with the Lithos
 * claims unenforced -- local development, mostly -- flags no workspace at all, and
 * the first in order is then the only one there is. A legacy workspace from before
 * tenancy loses to the flagged one, which is the right way round.
 */
export function tenantWorkspace(
  workspaces: readonly UserWorkspace[],
): UserWorkspace | undefined {
  const ordered = byOrder(workspaces)
  return ordered.find((workspace) => workspace.is_tenant_workspace) ?? ordered[0]
}
